import { render } from "./propertylist.vue?vue&type=template&id=c97aa6a0"
import script from "./propertylist.vue?vue&type=script&lang=js"
export * from "./propertylist.vue?vue&type=script&lang=js"

import "./propertylist.vue?vue&type=style&index=0&id=c97aa6a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__